import React from 'react'
import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api'

const containerStyle = {
  width: '1200px',
  height: '700px',
}

const center = {
  lat: 6.9271,
  lng: 79.8612,
}

function MyComponent() {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: 'AIzaSyAmqZYrHq6GGQzVj8YlD75gih1cu86H5D8',
  })

  const [map, setMap] = React.useState(null)

  const onLoad = React.useCallback(function callback(map) {
    // This is just an example of getting and using the map instance!!! don't just blindly copy!
    const bounds = new window.google.maps.LatLngBounds(center)
    map.fitBounds(bounds)

    setMap(map)
  }, [])

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null)
  }, [])

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={2}
      onLoad={onLoad}
      onUnmount={onUnmount}
    >
      {/* Child components, such as markers, info windows, etc. */}
      {/* Add markers to the map */}
      {/* <Marker position={center} label="Center" />
      <Marker position={{ lat: -3.746, lng: -38.524 }} label="Marker 1" />
      <Marker position={{ lat: -3.747, lng: -38.525 }} label="Marker 2" /> */}
      <Marker position={{ lat: 6.9271, lng: 79.8612 }} label="Colombo" />
      <></>
    </GoogleMap>
  ) : (
    <></>
  )
}

export default React.memo(MyComponent)